var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorPicker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.56 31.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "3.31 19.41 3.31 22.24 6.14 22.24 16.72 11.67 13.89 8.84 3.31 19.41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.97.59c-.78-.78-2.05-.78-2.83,0l-4.24,4.24,2.83,2.83,4.24-4.24c.78-.78.78-2.05,0-2.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.31,
    y: 3.43,
    width: 4,
    height: 9.63,
    rx: 1,
    ry: 1,
    transform: "translate(-.76 14.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.81,26.43l-2.5-2.5-2.5,2.5h.01c-.51.6-.83,1.35-.83,2.19,0,1.83,1.48,3.31,3.31,3.31s3.31-1.48,3.31-3.31c0-.84-.32-1.59-.83-2.17h.01Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPicker);
export default __webpack_public_path__ + "static/media/colorPicker.e93122b7db308bb08b3ea329161e92d6.svg";
export { ForwardRef as ReactComponent };